import React, { useState, useEffect } from "react";
import { Field } from "formik";
import Title from "../../../../title/title";
import APIProductService from "../../../../../services/APIProductService";
import {
  categoriesParser,
  parseApiProductsResponse,
} from "../../../../../constants/parse/product";

import { Tooltip as ReactTooltip } from "react-tooltip";
import { sortBy } from "lodash";
import { mapProductData } from "../../../../../constants/map/product";
import { CheckboxField } from "../../formFields";
import useUser from "../../../../../customHooks/useUser";
import useQuestionaire from "../../../hooks/useQuestionaire";

export default function ApiSelection() {
  const { uuid, csrfToken } = useUser();
  const { businessRepresentativeOptions } = useQuestionaire();

  // Transform questionnaire data to match expected format
  const parsedCategories = businessRepresentativeOptions.map((option) => ({
    uuid: option.id,
    name: option.label,
    id: option.id,
  }));

  return (
    <>
      <Title type="section">in which API category are you interested?</Title>
      {parsedCategories?.map((item) => (
        <div key={item.uuid} className="onboarding-api-selectable">
          <HoverableItem id={item.uuid}>
            <Field
              type="checkbox"
              name="field_product_categories"
              value={item.uuid}
              as={CheckboxField}
              label={item.name}
            />
          </HoverableItem>
        </div>
      ))}
    </>
  );
}

const HoverableItem = ({ children, id }) => {
  const { uuid: userId, csrfToken } = useUser();
  const [show, setShow] = useState(false);
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadProducts = async () => {
      if (show && !products) {
        try {
          setLoading(true);
          // Ensure the service has the full product list
          await APIProductService.getProductList(userId, csrfToken);
          // Get filtered products from service
          const filteredProducts = APIProductService.getProductsByCategory(id);
          setProducts(filteredProducts);
        } catch (error) {
          console.error("Error fetching products for category:", error);
          setProducts([]);
        } finally {
          setLoading(false);
        }
      }
    };

    loadProducts();
  }, [show, id, userId, csrfToken, products]);

  const getContent = () => {
    setShow(true);
  };

  return (
    <>
      <a style={{ cursor: "pointer" }} data-tip data-for={id}>
        {children}
      </a>
      <ReactTooltip
        id={id}
        aria-haspopup="true"
        role={`api-products=${id}`}
        type={"dark"}
        effect={"solid"}
        afterShow={getContent}
        afterHide={() => setShow(false)}
      >
        {loading || !products ? (
          <div>Loading...</div>
        ) : (
          sortBy(parseApiProductsResponse(mapProductData(products)), [
            "weight",
            "title",
          ]).map((product) => {
            const { uuid, title } = product;
            return <div key={uuid}>{title}</div>;
          })
        )}
      </ReactTooltip>
    </>
  );
};
